import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

export function useLanguageToggle() {
  const { i18n } = useTranslation();

  const isEnglish = useMemo(
    () => i18n.language === "en" || i18n.language.startsWith("en"),
    [i18n.language],
  );

  const toggle = useCallback(() => {
    void i18n.changeLanguage(isEnglish ? "hr" : "en");
  }, [i18n, isEnglish]);

  const languageTag = (i18n.resolvedLanguage ?? i18n.language)
    .slice(0, 2)
    .toUpperCase();

  /** Opposite language label for the switch (same as previous Sidebar behavior). */
  const switchTargetLabel = isEnglish ? "HR" : "EN";

  return { isEnglish, languageTag, switchTargetLabel, toggle };
}
